import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StammdatenService, Abweichung } from '@app/services/stammdaten.service';

export interface DialogData {
  mode: 'create' | 'edit';
  abweichung?: Abweichung;
}

@Component({
  selector: 'app-dialog-abweichung',
  templateUrl: './dialog-abweichung.component.html',
  styleUrls: ['./dialog-abweichung.component.css']
})
export class DialogAbweichungComponent implements OnInit {
  abweichungForm: FormGroup;
  isSubmitting = false;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<DialogAbweichungComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private stammdatenService: StammdatenService,
    private snackBar: MatSnackBar
  ) {
    this.abweichungForm = this.fb.group({
      caption: ['', Validators.required],
      description: ['', Validators.required],
      sortierung: [0, Validators.required],
      status: ['active', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data.mode === 'edit' && this.data.abweichung) {
      this.populateForm(this.data.abweichung);
    }
  }

  populateForm(abweichung: Abweichung): void {
    this.abweichungForm.patchValue({
      caption: abweichung.caption,
      description: abweichung.description,
      sortierung: abweichung.sortierung,
      status: abweichung.status
    });
  }

  onSubmit(): void {
    if (this.abweichungForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      const formData = this.abweichungForm.value;
      
      const abweichungData: Abweichung = {
        id: this.data.abweichung?.id || 0,
        caption: formData.caption,
        description: formData.description,
        sortierung: formData.sortierung,
        status: formData.status
      };

      if (this.data.mode === 'create') {
        this.stammdatenService.createAbweichung(abweichungData).subscribe({
          next: (response) => {
            this.snackBar.open('Abweichung erfolgreich erstellt', 'Schließen', { duration: 3000 });
            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('Error creating abweichung:', error);
            this.snackBar.open('Fehler beim Erstellen der Abweichung', 'Schließen', { duration: 3000 });
            this.isSubmitting = false;
          }
        });
      } else {
        this.stammdatenService.updateAbweichung(abweichungData.id, abweichungData).subscribe({
          next: (response) => {
            this.snackBar.open('Abweichung erfolgreich aktualisiert', 'Schließen', { duration: 3000 });
            this.dialogRef.close(response);
          },
          error: (error) => {
            console.error('Error updating abweichung:', error);
            this.snackBar.open('Fehler beim Aktualisieren der Abweichung', 'Schließen', { duration: 3000 });
            this.isSubmitting = false;
          }
        });
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
